import React from 'react'

function SoicalIcon({ data }) {
  return (
    <ul className="soical-icon">
      {data.map((item, index) => {
        return (
          <li key={index}>
            <a href={item.link} target="_blank" rel="noreferrer">
              <img src={item.images} alt={item.title} />
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export default SoicalIcon
